<template>
  <div class="col-sm-12">
    <div
      class="data-list-item add"
      @click.stop="$emit('add')"
    >
      <div class="item-img-cont add-title">
        <i class="fa fa-plus" />
      </div>
      <div class="item-text-cont">
        <span class="item-title-add">
          {{ $t('common.add_new') }}
        </span>
        <font-awesome-icon
          icon="tablet"
          class="card-body-icon"
        />
      </div>
    </div>

    <div class="col-12 list-container nopads">
        <Transition name="fade">
            <div v-if="resultList.length > 0" id="vehicle-list" class="list-content result-table pointer pb-2">
                <vue3-datatable
                    :rows="resultList"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    height="100%"
                    :sortable="true"
                    skin="bh-table-compact"
                    row-class="routa-table-row"
                    cell-class="routa-table-cell"
                    @row-click="emitData"
                >
                </vue3-datatable>
            </div>
        </Transition>
    </div>
  </div>
</template>

<script>
import Vue3Datatable from "@bhplugin/vue3-datatable";
import {vehicleHelper} from "@/components/mixins/VehicleMixin";

export default {
    name: 'TrackingDeviceList',
    components: {Vue3Datatable},
    mixins: [vehicleHelper],
    data() {
        return {
            fields: [
                {field: 'vehicle.license_plate', title: this.$t('ins_report.list_label.license_plate'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'vehicle.make', title: this.$t('vehicle_list.make'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'vehicle.vehicle_model', title: this.$t('vehicle_list.model'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'vehicle_type', title: this.$t('vehicle_list.type'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'imei', title: this.$t('tracking_devices.imei'),  sort: true, headerClass: 'routa-table-header'},
            ],
            resultList: []
        }
    },
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            },
        }
    },
    watch: {
        results() {
            let temp = [];
            this.resultList = [];
            this.results.forEach(item => {
                let newItem = { ...item };
                newItem.vehicle_type = item.vehicle ? this.getVehicleTypeName(item.vehicle.vehicle_type) : '';
                temp.push(newItem);
            });
            this.$nextTick(() => {
                this.resultList = temp;
            });
        }

    },
    mounted() {
        this.resultList = this.results
    },
    methods: {
        emitData(item) {
            let ot = this.results.find(o => o.imei === item.imei)
            if(ot) {
                this.$emit('edit', ot)
            }
        }
    }
}
</script>
